import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerSW } from './register-sw';
import { initTheme } from './core/Metronic';
import { setDarkMode } from './core/Global';
import Environment from './env/env';


// mark platform on <html> before React renders
(function markPlatform() {
  // add platform class to <html> as early as possible (Android-only)
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(ua);
  const isIOS = /iphone|ipad|ipod/.test(ua);
  if (isAndroid && !isIOS) {
    document.documentElement.classList.add('platform-android');
    // Optional PWA-only:
    // const isStandalone = (window.matchMedia?.('(display-mode: standalone)').matches) || ((navigator as any).standalone === true);
    // if (isStandalone) document.documentElement.classList.add('platform-android-standalone');
  }

  // If the native WebView host has already injected the flag before React boots,
  // mark <html> so global CSS can disable body scroll/rubber-band immediately.
  if ((window as any).__RINVOX_NATIVE_APP__ === true) {
    document.documentElement.classList.add('platform-native');
  }
})();

function isMobileDevice() {
  const ua = navigator.userAgent || '';
  const isMobileUA = /Android|iPhone|iPad|iPod/i.test(ua);
  const isTouchMac = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 0;
  const isSmallScreen = Math.min(window.innerWidth, window.innerHeight) <= 900;
  return isMobileUA || isTouchMac || isSmallScreen;
}

async function registerMobileSW() {
  if (!('serviceWorker' in navigator)) return;

  if (!isMobileDevice()) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map(r => r.unregister()));
    return;
  }

  try {
    await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  } catch (e) {
    console.error('SW register failed:', e);
  }
}


// Apply the saved theme choice (default: follow the device) before React paints,
// and keep following the OS while the choice stays "system".
initTheme(mode => setDarkMode(mode === "dark"));

// Settle on a healthy hub (primary first, then the backups) before anything calls it.
Environment.resolveHubUrl().finally(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerMobileSW();
//registerSW();